import {
  RawDraftContentBlock,
} from '@msd-npm-gmc-dev/gmc-dc-assembler-draftjs2lexical';
import { ParagraphNode, SerializedParagraphNode } from 'lexical';
import { SerializedLexicalNode } from 'lexical/LexicalNode';
import { getFormatTypeForBlockType } from 'modules/Lexical/Plugins/TextBlockPlugin/utils/horizontal-alignment';
import { TextHorizontalAlignmentType } from 'const';

export function createParagraphNode(
  contentBlock: RawDraftContentBlock,
  children: SerializedLexicalNode[],
): SerializedParagraphNode {
  const { depth, type } = contentBlock;

  return {
    children,
    direction: 'ltr',
    type: ParagraphNode.getType(),
    format: getFormatTypeForBlockType(type as TextHorizontalAlignmentType) ?? '',
    version: 1,
    textFormat: 0,
    indent: depth,
    textStyle: '',
  };
}
